<div class="homepage-layout">
  <div class="signin-text">
    <div *ngIf="!userName" id="staticLoginButtonDiv" class="loginButtonDiv" title="Login Button"></div>
    <div *ngIf="userName">{{userName}} (<a href="#" (click)="logoutClick($event)">Logout</a>)</div>
  </div>

  <!-- Anonymous navigation menu -->
  <nav class="anonymous-menu">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
    <a routerLink="/aboutus" routerLinkActive="active">About Us</a>
    <a routerLink="/privacy" routerLinkActive="active">Privacy Policy</a>
    <a routerLink="/terms" routerLinkActive="active">Terms of Use</a>
    <a routerLink="/contactus" routerLinkActive="active">Contact Us</a>
  </nav>

  <!-- Router outlet for child routes like privacy, terms, etc. -->
  <router-outlet></router-outlet>

</div>
